export const errorMessages = {
    e01101:(api_error_code, http_status) => `E01101:ニュース記事一覧取得に失敗しました。ニュース記事情報取得API実行時エラー:${api_error_code} ${http_status}`,
    e01102: "E01102:不正なニュース記事を取得しました。",
    e01201:(api_error_code, http_status) => `E01201:ニュース記事一覧取得に失敗しました。ニュース記事情報取得API実行時エラー:${api_error_code} ${http_status}`,
    e01202: "E01202:不正なニュース記事を取得しました。",
    e01203:(api_error_code, http_status) => `E01203:ニュース記事一覧取得に失敗しました。キーワード検索API実行時エラー:${api_error_code} ${http_status}`,
    e01301:(api_error_code, http_status) => `E01301:ニュース記事一覧取得に失敗しました。ニュース記事情報取得API実行時エラー:${api_error_code} ${http_status}`,
    e01401:(api_error_code, http_status) => `E01401:営業トーク例取得に失敗しました。営業トーク生成API実行時エラー:${api_error_code} ${http_status}`,
    e01: (articleId) => `E01:記事が見つかりませんでした。記事ID: ${articleId}`,
    e02: "E02:API エラーが発生しました。時間をおいて再度お試しください。",
    e03: "E03:エラーが発生しました。時間をおいて再度お試しください。",
};
